import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setTheme } from "../../store/themeSlice";
import "./style.css";

export const CircularThemeSwitch = () => {
  const theme = useAppSelector((state) => state.theme.theme);
  const dispatch = useAppDispatch();

  return (
    <div className="circular-theme-switch-container mr-4" style={{ minWidth: 24 }}>
      <input
        checked={theme === "dark"}
        onChange={(e) => {
          dispatch(setTheme(e.target.checked ? "dark" : "light"));
        }}
        type="checkbox"
        id="theme-toggle"
      />
      <label htmlFor="theme-toggle"></label>
    </div>
  );
};
